<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年05月12日 15:24:09 +0800
 * @最后修改时间: 2021-11-17 17:03:57
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Shift\ShiftList\components\copyFromShift.vue
 -->
<template>
  <normalDialog
    width="680"
    maxWidth="680"
    @close="closePorpertyDialog"
    :title="$t('label_essweb_shift_form_dialog_copyFromAnotherShift')"
    :dialog="show"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_shift_form_dialog_shiftNameLabel"
              :items="ShiftList"
              v-model="curShiftuuid"
              :rules="$GetRules(['_Require_Rules'], [null])"
              item-text="shift_name"
              item-value="uuid"
            >
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet
              class="max-width grey lighten-3 pa-6 rounded-lg"
              v-if="SiteList.length"
            >
              <div
                class="max-width rounded-lg mt-3"
                :style="{
                  overflow: 'hidden',
                  border: '1px solid var(--main-border-color)',
                }"
                v-for="(item, index) in SiteList"
                :key="index"
              >
                <div
                  class="
                    text-subtitle-2 text--secondary
                    pl-2
                    pa-3
                    text-capitalize
                  "
                  style="border-bottom: 1px solid var(--main-border-color)"
                >
                  {{ $getCommonLangValue(item.site_name) }}
                </div>
                <div
                  v-for="(it, i) in item.items"
                  :key="i"
                  :style="{
                    borderBottom:
                      i == item.items.length - 1
                        ? 'none'
                        : '1px solid var(--main-border-color)',
                  }"
                  class="
                    max-width
                    text--primary
                    pa-3
                    d-flex
                    flex-row
                    justify-space-between
                  "
                >
                  <div style="width: 33.33333%">
                    {{
                      $getCommonLangValue(it.criteriaType.criteria_type_name)
                    }}
                  </div>
                  <div style="width: 33.33333%" v-if="it.criteria != null">
                    {{
                      $getCommonLangValue(
                        it.criteriaType.punch_code == "GPS"
                          ? it.criteria.criteria_gps_name
                          : it.criteriaType.punch_code == "FACE"
                          ? it.criteria.criteria_facial_name
                          : it.criteriaType.punch_code == "WIFI"
                          ? it.criteria.criteria_wifi_name
                          : it.criteriaType.punch_code == "BLUETOOTH"
                          ? it.criteria.criteria_bluetooth_name
                          : ""
                      )
                    }}
                  </div>
                  <div style="width: 33.33333%" class="text-capitalize" v-else>
                    Null
                  </div>
                </div>
              </div>
            </v-sheet>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions newBtn @new="newProperty" @cancel="closePorpertyDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "copyFromShift",
  props: ["show", "curentShift"],
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
    curShift() {
      if (this.curShiftuuid) {
        return this.ShiftList.filter(
          (ele) => ele.uuid === this.curShiftuuid
        )[0];
      } else {
        return null;
      }
    },
    ShiftList() {
      return this.$getSelectTrans(this.ShiftListData, "shift_name");
    },
  },
  data() {
    return {
      curShiftuuid: null,
      SiteList: [],
      ShiftListData: [],
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.SiteList = [];
      } else {
        if (this.$refs["form"]) {
          this.$refs["form"].reset();
        }
      }
    },
    curShiftuuid(val) {
      if (val) {
        this.SiteList = [];
        this.getSiteByShift(val);
      } else {
        this.SiteList = [];
      }
    },
  },
  mounted() {
    this.getShiftList();
  },
  methods: {
    getShiftList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift",
        url: "/shift/get-shift-list/",
        data: {},
      }).then((res) => {
        that.ShiftListData = res.data.filter(
          (ele) => ele["uuid"] !== that.curentShift.toString() //去除当前shift
        );
      });
    },
    getSiteByShift: function (shift_uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_map_punch_criteria_site",
        url: "/condition-mapping/get-condition-mapping-list/",
        data: {
          searchType: "map",
          shift_uuid: shift_uuid,
        },
      }).then((res) => {
        that.SiteList = res.data;
      });
    },
    closePorpertyDialog: function () {
      this.$emit("close", false);
    },
    newProperty: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("new", this.SiteList);
    },
  },
};
</script>
